var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex align-items-stretch quick-filter-wrap",
    class: _vm.$attrs.class
  }, [_c('div', {
    staticClass: "label-dropdown position-relative"
  }, [_c('button', {
    staticClass: "dropdown-toggle text-capitalize",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_vm._v(" " + _vm._s(_vm.selectedLabel) + " ")]), _vm.dropdownOpen ? _c('ul', {
    staticClass: "dropdown-menu show ",
    staticStyle: {
      "position": "absolute",
      "top": "70%",
      "z-index": "10"
    }
  }, _vm._l(_vm.labels, function (label, index) {
    return _c('li', {
      key: index,
      class: {
        'selected-option': label === _vm.selectedLabel
      }
    }, [_c('a', {
      staticClass: "dropdown-item",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.selectLabel(label);
        }
      }
    }, [_vm._v(" " + _vm._s(label) + " ")])]);
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "dropdown-input-wrap position-relative flex-grow-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inputValue,
      expression: "inputValue"
    }],
    staticClass: "dropdown-input w-100 pe-5",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholders[_vm.selectedLabel]
    },
    domProps: {
      "value": _vm.inputValue
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.triggerSearch.apply(null, arguments);
      },
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value;
      }
    }
  }), _c('i', {
    staticClass: "fa fa-search position-absolute text-muted",
    staticStyle: {
      "top": "50%",
      "right": "1rem",
      "transform": "translateY(-50%)",
      "pointer-events": "none"
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }